(() => {
 if (window.avgarShellReady) return; window.avgarShellReady = true;
 const breakpoint = window.matchMedia('(min-width:750px)');
 function init(){
  document.querySelectorAll('.avgar-footer__links').forEach(d=>{d.open=breakpoint.matches;});
  document.querySelectorAll('.avgar-header details').forEach(d=>{
   if(d.dataset.bound) return; d.dataset.bound='true';
   d.addEventListener('keydown',e=>{if(e.key==='Escape'){d.open=false;d.querySelector('summary').focus();}});
   d.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>{d.open=false;}));
  });
 }
 init(); breakpoint.addEventListener('change',init);document.addEventListener('shopify:section:load',init);
})();